"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrameworkContext = exports.GoFwInstance = exports.GoFwInternalInstance = void 0;
var React = __importStar(require("react"));
var auth_service_1 = require("../utils/auth-service");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var GoFwInternal = (function () {
    function GoFwInternal() {
        var _this = this;
        this._onHostLoginListeners = [];
        this._onHostNavigationListeners = [];
        this._onSessionUpdateListeners = [];
        this._onEarnActivityListeners = [];
        this._onSessionCheckListeners = [];
        this.onHostLogin = function () {
            _this._onHostLoginListeners.forEach(function (listener) {
                try {
                    listener();
                }
                catch (e) {
                    console.error(e);
                }
            });
        };
        this.onHostNavigate = function (appNavigate) {
            _this._onHostNavigationListeners.forEach(function (listener) {
                try {
                    listener(appNavigate);
                }
                catch (e) {
                    console.error(e);
                }
            });
        };
        this.onSessionStatusUpdate = function (appSession) {
            _this._onSessionUpdateListeners.forEach(function (listener) {
                try {
                    listener(appSession);
                }
                catch (e) {
                    console.error(e);
                }
            });
        };
        this.onEarnActivity = function () {
            _this._onEarnActivityListeners.forEach(function (listener) {
                try {
                    listener();
                }
                catch (e) {
                    console.error(e);
                }
            });
        };
        this.getLedgerBalance = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, responseExp, error_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4, services_1.LedgerService.getLoyaltyPointsBalance()];
                    case 1:
                        response = _a.sent();
                        responseExp = void 0;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 6]);
                        return [4, services_1.LedgerService.getLoyaltyExpiryAmount()];
                    case 3:
                        responseExp = _a.sent();
                        return [3, 6];
                    case 4:
                        error_1 = _a.sent();
                        return [4, services_1.LedgerService.getLoyaltyPointsExpiring()];
                    case 5:
                        responseExp = _a.sent();
                        return [3, 6];
                    case 6:
                        if (response && response.balance) {
                            if (responseExp)
                                return [2, {
                                        balance: response.balance,
                                        expiringBalance: responseExp
                                    }];
                            else {
                                return [2, {
                                        balance: response.balance,
                                        expiringBalance: undefined
                                    }];
                            }
                        }
                        return [3, 8];
                    case 7:
                        e_1 = _a.sent();
                        return [3, 8];
                    case 8: return [2, {
                            balance: undefined,
                            expiringBalance: undefined
                        }];
                }
            });
        }); };
        this.getLoyaltyActiveSecondChanceEntries = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, services_1.PromotionsService.fetchActiveSecondChanceDrawForLoggedInPlayer()];
                    case 1: return [2, _a.sent()];
                    case 2:
                        e_2 = _a.sent();
                        return [3, 3];
                    case 3: return [2, undefined];
                }
            });
        }); };
        this.getLoyaltyActiveSweepstakesEntries = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, services_1.PromotionsService.fetchActiveSweepstakesDrawForLoggedInPlayer()];
                    case 1: return [2, _a.sent()];
                    case 2:
                        e_3 = _a.sent();
                        return [3, 3];
                    case 3: return [2, undefined];
                }
            });
        }); };
        this.getPendingPointsForTicketEntries = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, services_1.HistoryService.getPendingPointsForTicketEntries()];
                    case 1: return [2, _a.sent()];
                    case 2:
                        e_4 = _a.sent();
                        return [3, 3];
                    case 3: return [2, undefined];
                }
            });
        }); };
        this.getSessionDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, tokens, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, auth_service_1.AuthService.checkSession()];
                    case 1:
                        response = _a.sent();
                        if (response && response.status && response.status === 200) {
                            tokens = auth_service_1.AuthService.fetchFromLocalStorage();
                            return [2, {
                                    isValid: true,
                                    sessionToken: tokens.accessToken || undefined,
                                    email: tokens.email || undefined
                                }];
                        }
                        return [3, 3];
                    case 2:
                        e_5 = _a.sent();
                        return [3, 3];
                    case 3: return [2, {
                            isValid: false,
                            sessionToken: undefined,
                            email: undefined
                        }];
                }
            });
        }); };
        this.logout = function () { return __awaiter(_this, void 0, void 0, function () {
            var value_1, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, auth_service_1.AuthService.logout()];
                    case 1:
                        _a.sent();
                        return [4, this.getSessionDetails()];
                    case 2:
                        value_1 = _a.sent();
                        this.onSessionStatusUpdateListeners.forEach(function (listner) {
                            listner(value_1);
                        });
                        return [3, 4];
                    case 3:
                        e_6 = _a.sent();
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        this.getLoyaltySummary = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, ledgerPointsResult, secondChanceEntriesResult, sweepstakesEntriesResult, pendingPointsBalanceResult, pointsBalance, secondChanceDrawEntries, loyaltyDrawEntries, pendingPointsBalance, logError;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, Promise.all([
                            this.getLedgerBalance()
                                .then(function (result) { return ({ status: 'fulfilled', value: result == null ? 0 : result }); })
                                .catch(function (error) { return ({ status: 'rejected', reason: error }); }),
                            this.getLoyaltyActiveSecondChanceEntries()
                                .then(function (result) { return ({ status: 'fulfilled', value: result == null ? 0 : result }); })
                                .catch(function (error) { return ({ status: 'rejected', reason: error }); }),
                            this.getLoyaltyActiveSweepstakesEntries()
                                .then(function (result) { return ({ status: 'fulfilled', value: result == null ? 0 : result }); })
                                .catch(function (error) { return ({ status: 'rejected', reason: error }); }),
                            this.getPendingPointsForTicketEntries()
                                .then(function (result) { return ({ status: 'fulfilled', value: result == null ? 0 : result }); })
                                .catch(function (error) { return ({ status: 'rejected', reason: error }); })
                        ])];
                    case 1:
                        _a = _b.sent(), ledgerPointsResult = _a[0], secondChanceEntriesResult = _a[1], sweepstakesEntriesResult = _a[2], pendingPointsBalanceResult = _a[3];
                        pointsBalance = ledgerPointsResult.status === 'fulfilled'
                            ? ledgerPointsResult.value.balance
                            : undefined;
                        secondChanceDrawEntries = secondChanceEntriesResult.status === 'fulfilled'
                            ? secondChanceEntriesResult.value
                            : undefined;
                        loyaltyDrawEntries = sweepstakesEntriesResult.status === 'fulfilled'
                            ? sweepstakesEntriesResult.value
                            : undefined;
                        pendingPointsBalance = pendingPointsBalanceResult.status === 'fulfilled'
                            ? pendingPointsBalanceResult.value
                            : undefined;
                        logError = function (result, context) {
                            if (result.status === 'rejected') {
                                console.error("Failed to get ".concat(context, ":"), result.reason);
                            }
                        };
                        logError(ledgerPointsResult, 'ledger balance');
                        logError(secondChanceEntriesResult, 'second chance entries');
                        logError(sweepstakesEntriesResult, 'sweepstakes entries');
                        logError(pendingPointsBalanceResult, 'sweepstakes entries');
                        return [2, {
                                pointsBalance: pointsBalance,
                                secondChanceDrawEntries: secondChanceDrawEntries,
                                loyaltyDrawEntries: loyaltyDrawEntries,
                                pendingPointsBalance: pendingPointsBalance
                            }];
                }
            });
        }); };
    }
    Object.defineProperty(GoFwInternal.prototype, "onHostLoginListeners", {
        get: function () {
            return this._onHostLoginListeners;
        },
        set: function (value) {
            this._onHostLoginListeners = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFwInternal.prototype, "onHostNavigationListeners", {
        get: function () {
            return this._onHostNavigationListeners;
        },
        set: function (value) {
            this._onHostNavigationListeners = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFwInternal.prototype, "onSessionStatusUpdateListeners", {
        get: function () {
            return this._onSessionUpdateListeners;
        },
        set: function (value) {
            this._onSessionUpdateListeners = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFwInternal.prototype, "onSessionStatusCheckListeners", {
        get: function () {
            return this._onSessionCheckListeners;
        },
        set: function (value) {
            this._onSessionCheckListeners = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFwInternal.prototype, "onEarnActivityListeners", {
        get: function () {
            return this._onEarnActivityListeners;
        },
        set: function (value) {
            this._onEarnActivityListeners = value;
        },
        enumerable: false,
        configurable: true
    });
    return GoFwInternal;
}());
exports.GoFwInternalInstance = new GoFwInternal();
var GoFw = (function () {
    function GoFw() {
        var _this = this;
        this._login = null;
        this._showNumberChecker = null;
        this._showNumberCheckerGamesList = null;
        this._showNumberCheckerGameDetail = null;
        this._showPromotionList = null;
        this._showPromotionDetail = null;
        this._showHistory = null;
        this._showLogin = null;
        this._showForgotPassword = null;
        this._showResetPassword = null;
        this._showAccountReactivation = null;
        this._showActivation = null;
        this._showRegister = null;
        this._showSettings = null;
        this._showTicketEntry = null;
        this._showLottoGamesUnclaimedPrizes = null;
        this._showScratchGamesUnclaimedPrizes = null;
        this._showActivityList = null;
        this._showPromoCode = null;
        this._showGame = null;
        this._showHotCold = null;
        this._showViewUrl = null;
        this._showUploadContent = null;
        this._showPoll = null;
        this._showSurvey = null;
        this._showQuiz = null;
        this._showInvite = null;
        this._showRewardsList = null;
        this._showRewardDetail = null;
        this._showRewardsShortList = null;
        this._showEarnShortList = null;
        this._showSecondChanceShortList = null;
        this._loginWithTokenWithProvider = null;
        this._setRoute = null;
        this._showInteractiveGame = null;
        this._showCollectThemAll = null;
        this._showActivityDetails = null;
        this._showDrawCatalog = null;
        this._showDraw = null;
        this.onHostLogin = function (method) {
            exports.GoFwInternalInstance.onHostLoginListeners.push(method);
        };
        this.onHostNavigate = function (method) {
            exports.GoFwInternalInstance.onHostNavigationListeners.push(method);
        };
        this.onSessionStatusUpdate = function (method) {
            exports.GoFwInternalInstance.onSessionStatusUpdateListeners.push(method);
        };
        this.onEarnActivity = function (method) {
            exports.GoFwInternalInstance.onEarnActivityListeners.push(method);
        };
        this.getSessionDetails = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2, exports.GoFwInternalInstance.getSessionDetails()];
        }); }); };
        this.getLedgerBalance = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2, exports.GoFwInternalInstance.getLedgerBalance()];
        }); }); };
        this.getLoyaltyActiveSecondChanceEntries = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2, exports.GoFwInternalInstance.getLoyaltyActiveSecondChanceEntries()];
        }); }); };
        this.getLoyaltyActiveSweepstakesEntries = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2, exports.GoFwInternalInstance.getLoyaltyActiveSweepstakesEntries()];
        }); }); };
        this.getLoyaltySummary = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2, exports.GoFwInternalInstance.getLoyaltySummary()];
        }); }); };
        this.logout = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, exports.GoFwInternalInstance.logout()];
                case 1: return [2, _a.sent()];
            }
        }); }); };
        this.hostLogin = function (method) {
            exports.GoFwInternalInstance.onHostLoginListeners.push(method);
        };
        this.hostNavigate = function (method) {
            exports.GoFwInternalInstance.onHostNavigationListeners.push(method);
        };
    }
    Object.defineProperty(GoFw.prototype, "login", {
        get: function () {
            return this._login;
        },
        set: function (value) {
            this._login = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showNumberCheckerGamesList", {
        get: function () {
            return this._showNumberCheckerGamesList;
        },
        set: function (value) {
            this._showNumberCheckerGamesList = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showNumberCheckerGameDetail", {
        get: function () {
            return this._showNumberCheckerGameDetail;
        },
        set: function (value) {
            this._showNumberCheckerGameDetail = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showNumberChecker", {
        get: function () {
            return this._showNumberChecker;
        },
        set: function (value) {
            this._showNumberChecker = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showPromotionList", {
        get: function () {
            return this._showPromotionList;
        },
        set: function (value) {
            this._showPromotionList = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showActivityList", {
        get: function () {
            return this._showActivityList;
        },
        set: function (value) {
            this._showActivityList = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showPromotionDetail", {
        get: function () {
            return this._showPromotionDetail;
        },
        set: function (value) {
            this._showPromotionDetail = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showRewardDetail", {
        get: function () {
            return this._showRewardDetail;
        },
        set: function (value) {
            this._showRewardDetail = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showDraw", {
        get: function () {
            return this._showDraw;
        },
        set: function (value) {
            this._showDraw = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showDrawCatalog", {
        get: function () {
            return this._showDrawCatalog;
        },
        set: function (value) {
            this._showDrawCatalog = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showHistory", {
        get: function () {
            return this._showHistory;
        },
        set: function (value) {
            this._showHistory = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showLogin", {
        get: function () {
            return this._showLogin;
        },
        set: function (value) {
            this._showLogin = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showForgotPassword", {
        get: function () {
            return this._showForgotPassword;
        },
        set: function (value) {
            this._showForgotPassword = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showResetPassword", {
        get: function () {
            return this._showResetPassword;
        },
        set: function (value) {
            this._showResetPassword = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showAccountReactivation", {
        get: function () {
            return this._showAccountReactivation;
        },
        set: function (value) {
            this._showAccountReactivation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showActivation", {
        get: function () {
            return this._showActivation;
        },
        set: function (value) {
            this._showActivation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showRegister", {
        get: function () {
            return this._showRegister;
        },
        set: function (value) {
            this._showRegister = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showSettings", {
        get: function () {
            return this._showSettings;
        },
        set: function (value) {
            this._showSettings = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showTicketEntry", {
        get: function () {
            return this._showTicketEntry;
        },
        set: function (value) {
            this._showTicketEntry = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showLottoGamesUnclaimedPrizes", {
        get: function () {
            return this._showLottoGamesUnclaimedPrizes;
        },
        set: function (value) {
            this._showLottoGamesUnclaimedPrizes = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showScratchGamesUnclaimedPrizes", {
        get: function () {
            return this._showScratchGamesUnclaimedPrizes;
        },
        set: function (value) {
            this._showScratchGamesUnclaimedPrizes = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showGame", {
        get: function () {
            return this._showGame;
        },
        set: function (value) {
            this._showGame = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showHotCold", {
        get: function () {
            return this._showHotCold;
        },
        set: function (value) {
            this._showHotCold = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showPromoCode", {
        get: function () {
            return this._showPromoCode;
        },
        set: function (value) {
            this._showPromoCode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showViewUrl", {
        get: function () {
            return this._showViewUrl;
        },
        set: function (value) {
            this._showViewUrl = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showUploadContent", {
        get: function () {
            return this._showUploadContent;
        },
        set: function (value) {
            this._showUploadContent = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showPoll", {
        get: function () {
            return this._showPoll;
        },
        set: function (value) {
            this._showPoll = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showSurvey", {
        get: function () {
            return this._showSurvey;
        },
        set: function (value) {
            this._showSurvey = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showQuiz", {
        get: function () {
            return this._showQuiz;
        },
        set: function (value) {
            this._showQuiz = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showCollectThemAll", {
        get: function () {
            return this._showCollectThemAll;
        },
        set: function (value) {
            this._showCollectThemAll = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showInvite", {
        get: function () {
            return this._showInvite;
        },
        set: function (value) {
            this._showInvite = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showRewardsList", {
        get: function () {
            return this._showRewardsList;
        },
        set: function (value) {
            this._showRewardsList = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showRewardList", {
        get: function () {
            return this.showRewardsList;
        },
        set: function (value) {
            this.showRewardsList = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showRewardsShortList", {
        get: function () {
            return this._showRewardsShortList;
        },
        set: function (value) {
            this._showRewardsShortList = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "loginWithTokenWithProvider", {
        get: function () {
            return this._loginWithTokenWithProvider;
        },
        set: function (value) {
            this._loginWithTokenWithProvider = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "setRoute", {
        get: function () {
            return this._setRoute;
        },
        set: function (value) {
            this._setRoute = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showEarnShortList", {
        get: function () {
            return this._showEarnShortList;
        },
        set: function (value) {
            this._showEarnShortList = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showSecondChanceShortList", {
        get: function () {
            return this._showSecondChanceShortList;
        },
        set: function (value) {
            this._showSecondChanceShortList = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showInteractiveGame", {
        get: function () {
            return this._showInteractiveGame;
        },
        set: function (value) {
            this._showInteractiveGame = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoFw.prototype, "showActivityDetails", {
        get: function () {
            return this._showActivityDetails;
        },
        set: function (value) {
            this._showActivityDetails = value;
        },
        enumerable: false,
        configurable: true
    });
    return GoFw;
}());
exports.GoFwInstance = new GoFw();
exports.FrameworkContext = React.createContext({
    external: exports.GoFwInstance,
    internal: exports.GoFwInternalInstance
});
//# sourceMappingURL=framework.js.map